export default __webpack_public_path__ + "static/media/appmo.2729bbee.webp";